<template>
  <div class="container" v-cloak>
    <div class="top-con u-text-center">
      <img v-if="logoUrl" class="top-logo" :src="logoUrl" alt="logo" />
      <div class="top-con-tit">
        <h4 v-if="$route.query.insuranceResultKey && String($route.query.hasPushSuccess) === '0'">
          贷款申请结果
        </h4>
        <h4 v-else>恭喜您！贷款申请已成功</h4>
      </div>
    </div>

    <div class="mechanism-con">
      <div class="mechanism-info">
        <div class="pr">
          <!-- 未匹配上产品 -->
          <div class="u-flex-1 u-text-center mechanism-info-div" v-if="!productName">
            <div class="origan-desc">— 请注意接听该机构电话 —</div>
            <div class="u-flex u-row-between u-col-center">
              <p class="u-flex-1 origan-right">正在匹配中...</p>
            </div>
          </div>

          <!-- 匹配上产品 -->
          <template v-else>
            <div class="mechanism-info-div-success">
              <img
                class="success-phone"
                src="../../assets/images/image_orange/result/top_phone.png"
                alt=""
              />
              <div class="success-title">等待资方电话复审</div>
              <div class="success-tips">
                首次借款需资方客户经理电话联系您确认相关信息请注意接听!
              </div>
              <div class="success-info">
                <div class="success-info-name">
                  <span>{{ productName }}</span>
                </div>
                <div class="success-info-basic">
                  <div class="success-info-basic-label">最高可借金额：</div>
                  <div>¥ 200000</div>
                </div>
                <div class="success-info-basic" v-if="companyName">
                  <div class="success-info-basic-label">公司名称：</div>
                  <div>{{ companyName }}</div>
                </div>
                <!-- 半流程结果沿用接口同名字段，确保展示的是本次匹配产品的实际年化口径。 -->
                <div class="success-info-basic" v-if="annualRate">
                  <div class="success-info-basic-label">年化利率(单利)：</div>
                  <div>{{ annualRate }}(已包含全部息费)</div>
                </div>
                <div class="success-info-basic contract-row" v-if="agreements.length > 0">
                  <div class="success-info-basic-label">相关协议：</div>
                  <div class="contract-right">
                    <div class="contract-first-row">
                      <a :href="agreements[0].contractContent" target="_blank" class="contract-link"
                        >《{{ agreements[0].contractName }}》</a
                      >
                      <span
                        class="contract-toggle"
                        v-if="agreements.length > 1"
                        @click="contractExpanded = !contractExpanded"
                        ><span class="contract-toggle-icon" :class="{ rotated: contractExpanded }"
                          >∨</span
                        ></span
                      >
                    </div>
                    <div class="contract-collapse" :class="{ expanded: contractExpanded }">
                      <a
                        v-for="(contract, idx) in agreements.slice(1)"
                        :key="idx"
                        :href="contract.contractContent"
                        target="_blank"
                        class="contract-link"
                        >《{{ contract.contractName }}》</a
                      >
                    </div>
                  </div>
                </div>
                <div class="success-tips">*为保证电话复审通过，请你注意接听来电</div>
              </div>
            </div>
          </template>

          <van-button
            class="download-app-btn"
            type="default"
            @click="onUserConfirmQuotaClick"
            block
            v-if="isRedirectProductsPage == 1"
          >
            <span>确认额度</span>
          </van-button>
          <van-button
            class="download-app-btn"
            type="default"
            @click="onUserConfirmQuotaClick"
            block
            v-if="isRedirectProductsPage == 0"
          >
            <span>去app确认额度</span>
          </van-button>
        </div>

        <!-- 贷款流程 -->
        <div
          v-if="!($route.query.insuranceResultKey && String($route.query.hasPushSuccess) === '0')"
          class="pagecard"
        >
          <h4>贷款流程</h4>
          <ul class="u-flex u-text-center pagecard-process">
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_safe.png" />
              <h6>风控系统审核</h6>
              <div class="u-flex u-row-center">
                <img class="icon-img" src="../../assets/images/image_orange/result/icon_pass.png" />
                <span class="green">已通过</span>
              </div>
            </li>
            <li class="line pr">
              <img class="pa" src="../../assets/images/image_orange/result/icon_right.png" />
            </li>
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_phone.png" />
              <h6>电话复审</h6>
              <div class="u-flex u-row-center">
                <img
                  class="icon-img"
                  src="../../assets/images/image_orange/result/icon_dot_orange.png"
                />
                <span class="yellow">进行中</span>
              </div>
            </li>
            <li class="line pr">
              <img class="pa" src="../../assets/images/image_orange/result/icon_right.png" />
            </li>
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_money.png" />
              <h6 style="color: #c2c3c4">申请提现</h6>
              <div class="u-flex u-row-center">
                <img
                  class="icon-img"
                  src="../../assets/images/image_orange/result/icon_dot_gray.png"
                />
                <span class="default">等待电话复审</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 第三方金融产品 -->
        <!-- 保险结果只在本次投保成功返回并携带结果索引时展示，普通进件结果不受影响。 -->
        <InsuranceResult />
        <div class="pagecard" v-if="isRedirectProductsPage == 1 && productList.length > 0">
          <h4>第三方金融产品</h4>
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <div class="pagecard-product" :class="[productList.length == 1 ? '' : 'swiperPb']">
                <div class="pagecard-product-left">
                  <div class="pagecard-product-left-top">
                    <div class="pagecard-product-left-top-l">
                      <img
                        class="pagecard-product-logo"
                        :src="item.imgUrl ? item.imgUrl : '../../assets/images/img_mechanism.png'"
                      />
                      <div>
                        <div class="pagecard-product-name">
                          {{ item.productName }}
                          <van-tag
                            v-for="(tag, i) in item.tagList"
                            :key="i"
                            color="#FFF4EF"
                            text-color="#FFB481"
                            style="
                              margin-right: 0.06rem;
                              margin-bottom: 0.06rem;
                              border: 1px solid #ffb481;
                            "
                          >
                            {{ tag }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pagecard-product-left-bottom">
                    <div class="pagecard-product-left-bottom-item1">
                      <div class="item1-tit">可借额度范围（元）</div>
                      <div class="item1-text">￥{{ item.minAmount }}~{{ item.maxAmount }}</div>
                    </div>
                    <van-button class="pagecard-product-btn" @click="handleProductClick(item, 15)"
                      >立即申请</van-button
                    >
                  </div>
                  <!-- 贷超产品最大利率缺失时才按 24% 兜底。 -->
                  <div class="pagecard-product-left-rate">
                    综合年利率：{{ item.minLoanRate }}%~{{ item.maxLoanRate || 24 }}%
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination" v-if="productList.length > 1"></div>
          </swiper>
        </div>
      </div>
    </div>

    <!-- 下载APP -->
    <div class="downloadBtnContainer" v-if="isH5DownloadAppShow == 1">
      <van-button type="default" block class="download-app-btn" @click="handleDownload">
        <span class="span">下载闪借花APP</span>领取额度
      </van-button>
    </div>
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.2.js"></script>
<script>
import InsuranceResult from '@/components/InsuranceResult'
import * as API_Common from '@/api/common.js'
import { formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'
import Cookies from 'js-cookie'
import resultSuccessBuriedMixin from '@/mixins/resultSuccessBuriedMixin.js'
/**
 * 打开外部链接
 * @param {string} url - 要打开的外部链接地址
 */
function openExternalUrl(url) {
  if (typeof wx === 'undefined' || !wx.miniProgram || !wx.miniProgram.navigateTo) {
    console.error('wx.miniProgram.navigateTo 不可用，请确保在微信 web-view 环境中运行')
    return false
  }

  try {
    // 页面路径（我方已配置）
    const targetPage = '/pages/web-view/web-view'
    // 通过 URL 参数传递要打开的链接
    const targetUrl = `${targetPage}?url=${encodeURIComponent(url)}&action=openUrl`

    wx.miniProgram.navigateTo({
      url: targetUrl,
      success: function (res) {
        console.log('跳转成功', res)
      },
      fail: function (err) {
        console.error('跳转失败', err)
      },
    })
    return true
  } catch (error) {
    console.error('打开外部链接失败', error)
    return false
  }
}

export default {
  components: { InsuranceResult },
  name: 'resultHalfUnion',
  mixins: [resultSuccessBuriedMixin],
  data() {
    return {
      source: this.$route.query.source || '',
      isRedirectProductsPage: parseInt(this.$route.query.isRedirectProductsPage),
      isH5DownloadAppShow: parseInt(this.$route.query.isH5DownloadAppShow),
      processId: this.$route.query.processId || '',
      sign: this.$route.query.sign || '',
      tsp: this.$route.query.tsp || '',
      jwt: this.$route.query.jwt || '',
      tid: this.$route.query.downPageUrlTid || '',

      downAppUrl: undefined,
      productName: '',
      price: '',
      companyName: '',
      agreements: [],
      contractExpanded: false,

      swiperOptions: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          touchEnd: function () {
            this.autoplay.stop()
            setTimeout(() => {
              this.autoplay.start()
            }, 10000)
          },
        },
      },
      productList: [],

      annualRate: '', // 半流程结果接口返回的年化利率，空值时不展示
      logoUrl: '', // 机构logo
    }
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultHalfUnion'
  },
  mounted() {
    this.getLogoUrl()
    this.handleJwtLogin()
    this.getHalfUnionInfo()
    this.getDownloadUrl()
    this.getProductList()
  },
  methods: {
    getLogoUrl() {
      API_Common.getLogoUrl(this.source).then((res) => {
        if (res.code === 200) {
          this.logoUrl = res.data.logoUrl
        }
      })
    },
    handleJwtLogin() {
      if (this.jwt) {
        Cookies.set('token', this.jwt, { path: '/' })
      }
    },

    getHalfUnionInfo() {
      API_Common.getHalfReturnUrl({
        source: this.source,
        processId: this.processId,
        sign: this.sign,
      }).then((res) => {
        if (res && res.code === 200 && res.data) {
          try {
            const innerData =
              typeof res.data.data === 'string' ? JSON.parse(res.data.data) : res.data.data || {}
            this.productName = innerData.productName || ''
            this.price = innerData.price || ''
            this.companyName = innerData.companyName || ''
            this.annualRate = innerData.annualRate || ''
            this.agreements = innerData.agreements || []
          } catch (e) {
            console.error('解析半流程联登数据失败:', e)
          }
        }
      })
    },

    getDownloadUrl() {
      API_Common.getDownloadUrl(this.source, true).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },

    getProductList() {
      let obj = {
        channelCode: this.source || '',
        pageNum: 1,
        pageSize: 8,
        showPage: 15,
      }
      API_Common.h5CpaProductAllPageList(obj).then((res) => {
        if (res.code === 200) {
          this.productList = res.data.productPageVO.list || []
          if (this.productList.length <= 1) {
            this.swiperOptions.loop = false
          } else {
            this.swiperOptions.loop = true
          }
        }
      })
    },

    handleProductClick(obj, showPage) {
      this.trackResultSuccessApplyNow(obj && obj.productId != null ? String(obj.productId) : '')
      if (obj.checkMobileStatus != 0) {
        setTimeout(() => {
          window.location.href = `/productDetail?productId=${obj.productId}&showPage=${showPage}&source=${this.source}`
        }, 600)
      } else {
        API_Common.buried({
          productId: obj.productId,
          showPage,
        })
          .then((res) => {
            const productId = res.data.productId || obj.productId
            window.location.href =
              '/appFrame?productId=' + productId + '&url=' + formatAppFrameLinkUrl(res.data.linkUrl)
            sessionStorage.setItem('lastUrl', window.location.href)
          })
          .catch((error) => {
            console.error('产品实时校验失败', error)
          })
      }
    },

    handleDownload() {
      API_Common.handleBatchTrackBase(30202)
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else {
        if (this.brand === 'xiaomi') {
          window.location.href = 'https://app.xiaomi.com/detail/1500555'
        } else {
          setTimeout(() => {
            window.location.href = this.downAppUrl
          }, 50)
        }
      }
    },

    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },

    autoDownloadApp() {
      if (this.isWeixin()) {
        this.$toast('请在浏览器中打开此页面进行下载')
        return
      }
      this.$toast.loading({ message: '获取下载地址中...', forbidClick: true })
      API_Common.getDownloadUrl(this.source, true)
        .then((res) => {
          this.$toast.clear()
          if (res.code === 200 && res.data && res.data.url) {
            window.location.href = res.data.url
          } else {
            this.$toast.fail(res.msg || '下载地址获取失败，请稍后重试')
          }
        })
        .catch(() => {
          this.$toast.clear()
          this.$toast.fail('下载地址获取失败，请稍后重试')
        })
    },

    handleIGotIt() {
      this.runHalfDownloadOrElse(() => {
        const timestamp = new Date().getTime()
        if (this.isRedirectProductsPage == 1) {
          window.location.href = `/productListOrange.html?source=${this.source}&tsp=${timestamp}`
        } else {
          this.autoDownloadApp()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$primaryColor: #e71a0f;

.container {
  background: #f2f5fa;
  height: 100vh;
  overflow: auto;
  padding-bottom: 2rem;

  .top-con {
    position: relative;
    padding: 0.44rem 0 1.36rem;
    background: linear-gradient(40deg, #ff5612, #fd7539);
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: normal;
    color: #fff;
    text-align: center;

    .top-logo {
      position: absolute;
      left: 0.16rem;
      top: 0.16rem;
      width: 0.8rem;
      height: 0.8rem;
      object-fit: contain;
    }

    &-tit {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 1.26rem;
        height: 1rem;
      }

      h4 {
        position: relative;
        top: 0.1rem;
        font-size: 0.36rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
      }
    }
  }

  .mechanism-con {
    margin-top: -0.74rem;
    padding: 0 0.16rem;

    > .mechanism-info {
      margin-top: -0.1rem;
      padding: 0 0.24rem;

      .mechanism-info-div-success {
        margin-top: 10px;
        background: #ffffff;
        border-radius: 0.2rem;
        position: relative;
        padding: 1.14rem 0 0.2rem;
        text-align: center;

        .success-phone {
          width: 1.66rem;
          position: absolute;
          top: -0.83rem;
          left: calc(50% - 0.83rem);
        }

        .success-title {
          font-weight: 600;
          font-size: 0.36rem;
          color: #333333;
        }

        .success-tips {
          padding: 0 1.18rem;
          font-weight: 400;
          font-size: 0.22rem;
          color: #333333;
        }

        .success-info {
          margin-top: 0.28rem;
          border-top: 1px dotted #e6e5e5;
          padding: 0 0.32rem 0;

          .success-info-name {
            img {
              width: 0.42rem;
              height: 0.42rem;
              border-radius: 0.21rem;
              margin: 0.1rem;
            }

            span {
              font-weight: 600;
              font-size: 0.28rem;
              color: #333333;
            }
          }

          .success-info-basic {
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 0.22rem;
            color: #333333;
            margin-bottom: 0.24rem;

            .success-info-basic-label {
              color: #9a9a9a;
            }
          }

          .contract-row {
            align-items: flex-start;
          }

          .contract-right {
            flex: 1;
            min-width: 0;
            text-align: right;

            .contract-first-row {
              display: flex;
              align-items: center;
              justify-content: flex-end;
            }

            .contract-link {
              display: block;
              font-size: 0.22rem;
              color: #333333;
              text-decoration: none;
              line-height: 1.8;
            }

            .contract-toggle {
              flex-shrink: 0;
              margin-left: 0.12rem;
              cursor: pointer;
              user-select: none;

              .contract-toggle-icon {
                display: inline-block;
                font-size: 0.2rem;
                color: #bbbbbb;
                transition: transform 0.3s ease;
                vertical-align: middle;

                &.rotated {
                  transform: rotate(180deg);
                }
              }
            }

            .contract-collapse {
              max-height: 0;
              overflow: hidden;
              transition: max-height 0.35s ease;

              &.expanded {
                max-height: 12rem;
              }
            }
          }

          .success-tips {
            background: #fff4ef;
            border-radius: 0.12rem;
            color: #ff5d0e;
            padding: 0.12rem 0 0.12rem 0.2rem;
          }
        }
      }

      .mechanism-info-div {
        width: 100%;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.2rem;
        padding: 0.22rem 0.3rem 0.36rem;
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #838f9f;

        .origan-desc {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Thin;
          font-weight: normal;
          color: #111c31;
          line-height: 0.34rem;
          margin-bottom: 0.4rem;
        }

        .origan-right {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #111c31;
        }
      }

      .swiperPb {
        padding-bottom: 0.8rem !important;
      }

      .pagecard {
        margin-top: 0.16rem;
        background: #ffffff;
        border-radius: 0.24rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        padding: 0.32rem;
        box-sizing: border-box;

        > h4 {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: normal;
          color: #333333;
          margin-bottom: 0.24rem;

          span {
            margin-left: 0.1rem;
            font-size: 0.24rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: normal;
            color: #666;
          }
        }

        &-process {
          background-color: #fff;
          border-radius: 0.3rem;
          margin-top: 0.3rem;

          .loan-process-li {
            > img {
              width: 0.64rem;
              height: 0.64rem;
              border-radius: 50%;
            }

            .icon-img {
              width: 0.22rem;
              height: 0.22rem;
              border-radius: 50%;
              margin-right: 0.06rem;
            }

            h6 {
              font-size: 0.24rem;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: normal;
              color: #333333;
              margin: 0.2rem 0 0.2rem;
            }

            span {
              color: #7d8090;
              font-size: 0.22rem;
            }

            span.default {
              color: #c2c3c4;
            }
          }

          .line {
            width: 0;

            > img {
              width: 0.6rem;
              height: 0.12rem;
              right: -0.3rem;
              top: -0.36rem;
            }
          }
        }

        &-product {
          margin-top: 0.24rem;
          background: url('../../assets/images/image_orange/result/pro_bg.png') no-repeat;
          background-size: 100% 3rem;
          padding: 0.26rem 0.28rem 0.24rem 0.28rem;
          width: 6rem;

          &-logo {
            width: 0.36rem;
            height: 0.36rem;
            border-radius: 0.08rem;
            margin-right: 0.16rem;
          }

          &-name {
            font-size: 0.28rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: normal;
            color: #333;
            margin-right: 0.02rem;
            margin-bottom: 0.08rem;
          }

          &-btn {
            color: #fff;
            border-radius: 0.32rem;
            height: 0.64rem;
            line-height: 0.64rem;
            background: #fd6f34;
            flex-shrink: 0;
            font-size: 0.24rem;
          }

          &-left {
            &-top {
              margin-bottom: 0.24rem;

              &-l {
                display: flex;
                align-items: center;
              }
            }

            &-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-bottom: 0.2rem;
              border-bottom: 1px dotted #e5e5e5;

              &-item1 {
                width: 60%;

                .item1-tit {
                  flex-shrink: 0;
                  margin-right: 0.2rem;
                  margin-bottom: 0.2rem;
                  font-size: 0.22rem;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: normal;
                  color: #7d7f93;
                }

                .item1-text {
                  font-size: 0.36rem;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: bold;
                  color: #fd6f34;
                }
              }
            }

            &-rate {
              height: 0.6rem;
              padding: 0.18rem 0;
              font-weight: 500;
              color: #aa664a;
            }
          }
        }
      }
    }
  }
}

.downloadBtnContainer {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.34rem 0.54rem;
  background-color: #fff;
  box-shadow: 0 -0.2rem 0.1rem 0.06rem rgba(0, 0, 0, 0.03);
}

.download-app-btn {
  font-size: 0.32rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
  box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
  border-radius: 0.54rem;
  margin: 0.2rem 0;

  .span {
    font-weight: bold;
  }
}
</style>

<style>
.swiper-pagination {
  text-align: center !important;
}

.swiper-pagination-bullet {
  width: 0.12rem;
  height: 0.12rem;
  background: #ccc;
  opacity: 0.5;
  margin: 0 0.06rem;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: #ff4040;
}
</style>
